import api from "@/services/api";

/**
 * @description Servicio para el módulo de validaciones de prestaciones médicas.
 * Conecta con el motor de validación del backend (4 capas de verificación).
 */
const validationService = {};
const endpoint = "/validations";

/**
 * @description Ejecuta la validación completa de una prestación (flujo doctor_ui).
 * El prestador es siempre el usuario logueado en el backend.
 * @param {string} memberId - ID del afiliado
 * @param {string} practiceId - ID de la prestación del catálogo
 * @param {string} token - Token TOTP del afiliado
 * @returns {Promise<{approved, rejectionReasons, checks, valorization, recordId}>}
 */
validationService.validate = (memberId, practiceId, token) =>
  api
    .post(`${endpoint}/validate`, { memberId, practiceId, token })
    .then((r) => r.data);

/**
 * @description Obtiene historial de validaciones con filtros.
 * Doctor ve solo las suyas. Admin ve todas.
 * @param {Object} params - Filtros opcionales: status, year, month, memberId, providerId, offset, limit
 */
validationService.get = (params = {}) =>
  api.get(endpoint, { params }).then((r) => r.data);

/**
 * @description Busca prestaciones disponibles para el prestador logueado
 * (solo las que tiene en contrato activo y vigente).
 *
 * UC-REG-165 — cuando se pasa `memberId`, la respuesta trae `{ covered,
 * notCovered }` particionado por el plan del afiliado. Sin `memberId`
 * mantiene el shape legacy `{ docs, total }`.
 *
 * @param {string} [searchInput] - Filtro por código o nombre
 * @param {string} [memberId] - ID del afiliado para partición por plan
 */
validationService.getMyPractices = (searchInput = "", memberId = null) => {
  const params = { searchInput };
  if (memberId) params.memberId = memberId;
  return api.get(`${endpoint}/my-practices`, { params }).then((r) => r.data);
};

export default validationService;
